import { Img } from "../../../layout/Img"

export const FullImage = ({ picture, caption }) => {
  return (
    <div className="container justify-center w-full px-4 mx-auto text-center md:px-24 xl:px-36">
      <Img image={picture[0]} className="w-auto h-full" />
      <figcaption>{caption}</figcaption>
    </div>
  )
}
